import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { Card as CardToolkit } from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../../enums';

type Props = {
	mode: string;
};

const viewMode = `
    border-left: 1px solid ${palette.mlcDove};
    border-top: 2px solid ${palette.mlcDove};
`;

const editMode = `
    border-left: 1px solid ${palette.mlcAqua};
    border-top: 2px solid ${palette.mlcAqua};
`;

export const Card = styled(CardToolkit)`
	grid-template-columns: 25% 68% 7%;

	${(p: Props) => (p.mode === 'view' ? viewMode : editMode)} .veEdit {
		text-align: right;
	}

	@media (max-width: ${ScreenSize.small}) {
		grid-template-columns: auto 1fr;

		div:nth-child(3) {
			grid-column: 2;
			grid-row: 1;
		}

		div:nth-child(2) {
			grid-column: 1;
		}
	}

	@media (min-width: ${ScreenSize.small}) and (max-width: ${ScreenSize.medium}) {
		div:nth-child(1) > p {
			margin-right: 10px;
		}
	}
`;
